module.exports = __webpack_public_path__ + "img/10.8aa3529b.jpg";